<template lang="html">
  <div>
    <h1>Send Notification for mobile applications</h1>
    <hr />
    <v-layout row align-start class="pt-4">
      <v-text-field clearable small label="Title" v-model="notificationTitle"></v-text-field>
    </v-layout>
    <v-layout row align-start class="pt-4">
      <v-textarea clearable large label="Body" v-model="notificationBody"></v-textarea>
    </v-layout>
    <v-layout style="margin: 10px 0px;">
      <v-checkbox v-model="all" label="For all" @click="forAll" style="margin: 0 10px;"></v-checkbox>
      <v-checkbox v-model="teachers" label="For teachers only" @click="forTeacher" style="margin: 0 10px;"></v-checkbox>
      <v-checkbox v-model="promo" label="For promo only" @click="forPromo" style="margin: 0 10px;"></v-checkbox>
    </v-layout>
    <v-layout v-if="promo">
      <v-text-field solo label="Search by code or client" v-model="search" @input="sortPromosBySearch"></v-text-field>
    </v-layout>
    <v-layout v-if="promo">
      <v-select style="padding: 20px 20px 0px 20px;" @input="sync" label="Select promo" v-model="promos.promo" chips
        :items="promos.promos" item-text="value" item-value="id_promo" solo></v-select>
    </v-layout>
    <v-layout row align-start class="pt-4">
      <v-btn @click="saveOption" color="success">SEND</v-btn>
    </v-layout>
    <hr style="margin-top: 75px;"/>
    <hr style="margin-bottom: 75px;"/>

    <h1>Default settings for notifications scheduler</h1>
    <v-layout row align-start class="pt-4">
      <v-text-field clearable small label="Heading" v-model="defaultNotification.header"></v-text-field>
    </v-layout>
    <v-layout row align-start class="pt-4">
      <v-textarea clearable large label="Description" v-model="defaultNotification.description"></v-textarea>
    </v-layout>
    <div style="margin-top: 25px;">
      <v-row style="background-color: rgb(230, 230, 230); margin-bottom: 10px;align-items: center;" v-for="(item, index) in defaultNotification.data" :key="index">
        <v-col style="text-align: center;">
          <div>{{ item.day }}</div>
        </v-col>
        <v-col style="text-align: center;">
          <div>{{ item.time }}</div>
        </v-col>
        <v-col style="text-align: center;">
          <v-btn color="error" @click="deleteRow(index)">Delete</v-btn>
        </v-col>
      </v-row>
    </div>
    <v-container v-if="defaultNotification!=null && defaultNotification.data.length<7">
      <v-row style="align-items: center;">
        <v-col>
          <v-select
            v-model="selectedDay"
            :items="daysOfWeek"
            label="Select a day"
          ></v-select>
        </v-col>
        <v-col style="max-width: 290px !important;">
          <v-menu
            v-model="timePicker"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="selectedTime"
                label="Select a time"
                prepend-icon="mdi-clock-time-three"
                readonly
                v-on="on"
              ></v-text-field>
            </template>

            <v-time-picker v-model="selectedTime" :allowed-minutes="allowedStep"></v-time-picker>
          </v-menu>
        </v-col>
        <v-col>
          <v-btn color="success" @click="addRow">Add</v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-layout row align-start class="pt-4" style="margin-bottom: 20px;">
      <v-btn color="success" @click="updateModel">Update default settings</v-btn>
    </v-layout>
  </div>
</template>
  
<script>
import CryptoJS from "crypto-js";
import { Base64 } from 'js-base64';
export default {
  name: "playlist",
  data() {
    return {
      timePicker: false,
      selectedTime: null,
      selectedDay: null,
      daysOfWeek: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      selectedTime:null,
      defaultNotification: null,
      notificationTitle: null,
      notificationBody: null,
      all: false,
      teachers: false,
      promo: false,
      promoValue: null,
      promos: {
        promos: null,
        promosDefault: null,
        promo: null
      },
      search: '',
    }
  },
  methods: {
    allowedStep: m => m % 5 === 0,
    updateModel(){
      axios.post('/admin/unpdateDefaultModel',this.defaultNotification).then(res => {
        this.$notify({
            title: "success",
            text: "Updated!",
            type: "success",
            duration: 5000,
          });
      }).catch(err=>{
        this.$notify({
            title: "error",
            text: "Error on update",
            type: "error",
            duration: 5000,
          });
      });
    },
    addRow(){
      this.defaultNotification.data.push({day:this.selectedDay,time:this.selectedTime});
      this.selectedDay = null;
      this.selectedTime = null;
    },
    getDefaultModel() {
      axios.get('/admin/getDefaultModel').then(res => {
        this.defaultNotification = res.data;
      });
    },
    deleteRow(indexToRemove){
      this.defaultNotification.data.splice(indexToRemove, 1);
    },
    saveOption() {
      if (this.notificationBody != null && this.notificationBody != "" && this.notificationTitle != null && this.notificationTitle != "") {
        if (this.promo == true && this.promos.promo == '') {
          alert('All fields are required!');
        }
        else {
          axios.post('/admin/sendNotification',
            {
              title: this.notificationTitle,
              body: this.notificationBody,
              all: this.all,
              teachers: this.teachers,
              promo: this.promo,
              promos: this.promos.promo
            }).then(res => {
              alert('Notifications was send successfuly!');
            });
        }
      }
      else {
        alert('All fields are required!');
      }
    },
    forAll() {
      this.all = true;
      this.teachers = false;
      this.promo = false;
    },
    forTeacher() {
      this.all = false;
      this.teachers = true;
      this.promo = false;
    },
    forPromo() {
      this.all = false;
      this.teachers = false;
      this.promo = true;
    },
    getPromoCodes() {
      axios.get('/admin/promo').then(res => {
        this.promos.promosDefault = res.data.sort((a, b) => a.client.toLowerCase() > b.client.toLowerCase() ? 1 : -1);
        this.promos.promos = res.data.sort((a, b) => a.client != '' && b.client != '' ? (a.client.toLowerCase() > b.client.toLowerCase() ? 1 : -1) : -1);
      });
    },
    sortPromosBySearch(e) {
      this.promos.promos = this.promos.promosDefault.filter(x => x.value.toLowerCase().includes(e.toLowerCase()) || x.client.toLowerCase().includes(e.toLowerCase()));
      this.promos.promos = this.promos.promos.sort((a, b) => (a.client != "" ? a.client : Infinity) > (b.client != "" ? b.client : Infinity));
    },
  },
  activated() {

  },
  async created() {
    this.getPromoCodes();
    this.getDefaultModel();
  },
};
</script>
  
<style lang="scss" scoped>
.style-one {
  border: 0;
  height: 1px;
  background: #333;
  background-image: linear-gradient(to right, #ccc, #333, #ccc);
}

.pagination {
  display: inline-block;
  padding-left: 0;
  margin: -10px 5px !important;
  border-radius: 4px;
}
</style>
  